<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
	series: {
		type: Array,
		required: true,
	},
	labels: {
		type: Array,
		required: true,
	},
	options: {
		type: Array,
		required: true,
	},
});

const CHART_COLORS = ['#FF6967', '#FF9D6D', '#FFE68C', '#D0DB54', '#9EDF93'];

const legendItems = computed(() =>
	props.options.map((option, index) => ({
		label: option.label,
		percent: option.percent,
		color: CHART_COLORS[index % CHART_COLORS.length],
	}))
);

const chartOptions = computed(() => ({
	chart: {
		type: 'pie',
		toolbar: { show: false },
	},
	labels: props.labels,
	colors: legendItems.value.map((item) => item.color),
	legend: { show: false },
	tooltip: {
		y: {
			formatter: (value) => `${value}`,
		},
	},
}));
</script>

<template>
	<div class="pie-chart flex items-center gap-8 flex-wrap w-full justify-center">
		<apexchart
			class="pie-chart__graph shrink-0"
			type="pie"
			height="200"
			width="200"
			:series="props.series"
			:options="chartOptions"
		/>
		<ul class="pie-chart__legend flex flex-col gap-3">
			<li
				v-for="(item, index) in legendItems"
				:key="index"
				class="pie-chart__legend-item flex items-center gap-2 text-sm text-neutral-700"
			>
				<span
					class="pie-chart__legend-dot w-3 h-3 rounded-full shrink-0 mt-0.5"
					:style="{ backgroundColor: item.color }"
				/>
				<span class="pie-chart__legend-label">
					{{ item.label }}
				</span>
				<span class="text-neutral-700 font-semibold shrink-0 ">
					{{ item.percent }}%
				</span>
			</li>
		</ul>
	</div>
</template>

<style scoped>
.pie-chart__legend-item {
	min-height: 1.5rem;
}

</style>
